webpackJsonp([70144966829960],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contact = function contact() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "width-container" },
	      _react2.default.createElement(
	        "div",
	        { className: "width-container-img-text d-flex align-items-center justify-content-center" },
	        _react2.default.createElement(
	          "video",
	          { autoPlay: true, muted: true, width: "400px", loop: true },
	          _react2.default.createElement("source", {
	            src: 'https://res.cloudinary.com/ditqglru2/video/upload/v1742848908/final_with_bg_cut_mral5d.mov',
	            type: "video/mp4"
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-left", style: { marginLeft: '-20px' } },
	          "For any information, question or curiosity, please contact me at: ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:migueelbettencourt@gmail.com", style: { textDecoration: "none" } },
	            _react2.default.createElement(
	              "span",
	              { className: "font-weight-bold text-dark" },
	              "migueelbettencourt@gmail.com "
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-51bc9b2fbfeeb4fb052c.js